export default __webpack_public_path__ + "fd6b3d9c0e69dca3feaf622feb525ed3.jpg";